import React from 'react'
import {
	GeneralContentWrapper,
	GeneralTitle
} from '../../../components/Shared/GeneralComponents'

const AboutUs = () => {
	return (
		<GeneralContentWrapper>
			<GeneralTitle text="About us" />
		</GeneralContentWrapper>
	)
}

export default AboutUs
